<app-structured-data [json]="itemListSchema"></app-structured-data>

<section
    class="product-filter"
    [ngClass]="{ 'product-filter-category-result': filterType() === filterTypes.CategoryResult }"
>
    <div class="container">
        <div class="row">
            <div class="col-2 d-none d-lg-block" *ngIf="filterType() === filterTypes.CategoryResult">
                <h2 class="navigation-headline display-4">
                    {{ (filterNavigationService.navigation$ | async)?.branchRoot?.name }}
                </h2>
                <app-category-navigation
                    *ngIf="filterNavigationService.navigation$ | async"
                    [pageViewModel]="filterNavigationService.navigation$ | async"
                    [breadCrumbs]="pageBreadCrumbs"
                    [activeId]="filterPageId"
                ></app-category-navigation>
            </div>

            <div class="col-12" [ngClass]="{ 'col-lg-10': filterType() === filterTypes.CategoryResult }">
                <h1 [ngClass]="filterType() === filterTypes.CategoryResult ? 'display-2' : 'display-3'"
                    #titleElementRef>
                    <ng-container *ngIf="filterType() === filterTypes.SearchResult; else pageTitle">
                        <span class="kk-ellipsis-loading" *ngIf="isPendingDelayed$ | async; else headlineNoResults">{{
                                (filterService.queryParams$ | async | getSearchParam).length
                                    ? ('filter.searchingFor'
                                        | translateSafe
                                        | formatString
                                        : {
                                            query: filterService.queryParams$ | async | getSearchParam
                                        })
                                    : ('filter.searching' | translateSafe)
                            }}</span>
                        <ng-template #headlineNoResults>
                            <ng-container
                                *ngIf="
                                    !((filterService.filter$ | async)?.total | existsAndGreaterThanZero);
                                    else pageTitle
                                "
                            >
                                {{
                                    'filter.noSearchResults'
                                        | translateSafe
                                        | formatString
                                        : {
                                            query: filterService.queryParams$ | async | getSearchParam
                                        }
                                }}
                            </ng-container>
                        </ng-template>
                    </ng-container>
                    <ng-template #pageTitle>
                        {{ title }}
                    </ng-template>
                </h1>
                <div class="row">
                    <header
                        class="col-12 sticky"
                        [ngStyle]="{ top: (filterStickyOffset$ | async) + 'px' }"
                        *ngIf="isDesktopOrLarger()"
                    >
                        <div class="sticky-inner">
                            <app-filter-facets
                                (facetUpdate)="
                                    filterService.update($event);
                                    scrollService.scrollTo(titleElementRef, {
                                        ignoreIfVisible: true,
                                        behavior: 'auto'
                                    })
                                "
                                [facetGroups]="(filterService.filter$ | async)?.facets"
                            >
                            </app-filter-facets>
                        </div>
                    </header>

                    <div class="col-12 d-none d-lg-block">
                        <app-facet-tags
                            *ngIf="
                                (filterService.queryParams$ | async | toFacetExposedCollection).length &&
                                (filterService.filterList$ | async)?.length !== 0
                            "
                            [facets]="filterService.queryParams$ | async | toFacetExposedCollection"
                            [facetGroups]="(filterService.filter$ | async)?.facets"
                            (resetFacets)="filterService.reset()"
                            (updateFacets)="filterService.update($event)"
                        ></app-facet-tags>
                    </div>

                    <div class="col-12 section filter-header">
                        <div class="result-count">
                            <h2
                                class="display-5 result-count"
                                *ngIf="
                                    (filterService.filter$ | async)?.total && filterType() === filterTypes.CategoryResult
                                "
                            >
                                {{
                                    'filter.resultCount'
                                        | translateSafe: { result: (filterService.filter$ | async)?.total }
                                }}
                            </h2>

                            <app-result-count
                                [total]="(filterService.filter$ | async)?.total"
                                [searchTerm]="filterService.queryParams$ | async | getSearchParam"
                                *ngIf="filterType() === filterTypes.SearchResult"
                            ></app-result-count>
                        </div>

                        <div class="filter-head-actions">
                            <div class="store-stock d-block d-lg-none">
                                <app-store-stock-facet
                                    *ngIf="!isDesktopOrLarger()"
                                    [disabled]="storeStockDisabled"
                                    (filterByStoreChange)="filterService.update($event)"
                                ></app-store-stock-facet>
                            </div>
                            <div class="same-day-delivery d-block d-lg-none">
                                <app-same-day-delivery-facet
                                    *ngIf="!isDesktopOrLarger()"
                                    (sameDayDeliveryChange)="onSameDayDeliveryChange($event)"
                                ></app-same-day-delivery-facet>
                            </div>
                            <div class="sorting">
                                <app-sorting
                                    *ngIf="
                                        (filterService.filter$ | async)?.sortOptions?.length &&
                                        ((filterService.filter$ | async)?.total | existsAndGreaterThanZero)
                                    "
                                    (sortOptionUpdate)="filterService.update($event)"
                                    [sortOptions]="(filterService.filter$ | async)?.sortOptions"
                                ></app-sorting>
                            </div>
                            <div class="mobile-filter d-block d-lg-none">
                                <button
                                    *ngIf="(filterService.filter$ | async)?.facets?.length"
                                    class="kk-btn kk-btn_secondary mobile-filter-button"
                                    (click)="openMobileFilter()"
                                >
                                    <app-filter-count
                                        *ngIf="
                                            (filterService.queryParams$ | async | toFacetExposedCollection)
                                                ?.length as count
                                        "
                                        [count]="count"
                                    ></app-filter-count>
                                    {{ 'filter.buttonText.mobileFilter' | translateSafe }}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div
                        #scrollElement
                        (appNgAfterViewInit)="scrollService.setScrollElement(scrollElement)"
                        class="col-12 section"
                        [ngClass]="{
                            'list-pending': (filterService.pending$ | async),
                            'list': filterType() === filterTypes.CategoryResult
                        }"
                    >
                        <div class="row" *ngIf="!(filterService.filter$ | async)?.initial; else pending">

                            @for (retailProduct of filterService.retailMediaResults(); track 'retail-media-' + retailProduct.productNo; let i = $index) {
                                <div class="product-card col-12 col-sm-6 col-md-4 col-lg-3"
                                     [attr.id]="retailProduct.variantNo"
                                     [appImpressionTracking]="retailProduct"
                                     [impressionSource]="
                                        filterType() === filterTypes.SearchResult ? 'Retail Media Sponsored Products' : 'Other'
                                     "
                                     [index]="i + 1"
                                >
                                    <app-product-card
                                        [line]="retailProduct"
                                        [index]="i + 1"
                                        [displayActions]="true"
                                        [impressionSource]="
                                        filterType() === filterTypes.SearchResult ? 'Retail Media Sponsored Products' : 'Other'
                                    "
                                    ></app-product-card>
                                </div>
                            }

                            <div *ngFor="let line of filterService.filterList$ | async;
                                let i = index;
                                trackBy: trackProductFn"
                                 class="product-card col-12 col-sm-6 col-md-4 col-lg-3"
                                 [style.order]="(i + 1)"
                                 [attr.id]="line.variantNo"
                                 [appImpressionTracking]="line"
                                 [impressionSource]="
                                    filterType() === filterTypes.SearchResult ? 'Search Results' : 'Other'
                                "
                                 [index]="i + 1"
                            >
                                <app-product-card
                                    [line]="line"
                                    [index]="i + 1"
                                    [displayActions]="true"
                                    [impressionSource]="
                                        filterType() === filterTypes.SearchResult ? 'Search Results' : 'Other'
                                    "
                                ></app-product-card>
                            </div>

                            @if (((filterPageId | getUspCard) | async); as USPCards) {
                                @for (card of USPCards; track card.position; let i = $index) {
                                    <div class="product-card col-12 col-sm-6 col-md-4 col-lg-3"
                                         [style.order]="(card?.position || 0) - 1"
                                         appPromotionImpressionTracking
                                         [promotion]="{
                                            'creative_name': 'USP Spot - PLP',
                                            'creative_slot': title ?? '',
                                            'promotion_id': '',
                                            'promotion_name': card?.title ?? '',
                                            'index': (card?.position || 0) - 1
                                         }"
                                         [index]="(card?.position || 0) - 1">
                                        <app-product-usp-card
                                            [title]="title"
                                            [data]="card"
                                            [index]="(card?.position || 0) - 1"
                                        >
                                        </app-product-usp-card>
                                    </div>
                                }
                            }
                        </div>
                        <div
                            class="col-12"
                            *ngIf="
                                (filterService.filterList$ | async)?.length === 0 &&
                                !(filterService.filter$ | async)?.initial
                            "
                        >
                            <div class="no-result-container" *ngIf="filterType() === filterTypes.CategoryResult">
                                <div>
                                    {{ 'filter.noResults' | translateSafe }}
                                </div>
                                <button
                                    class="kk-icon-btn kk-icon-btn_reverse reset-button"
                                    (click)="filterService.reset({ take: filterService.defaultTakeAmount })"
                                >
                                    <app-svg-icon aria-hidden="true" iconName="trash"></app-svg-icon>
                                    {{ 'filter.buttonText.removeActiveFilters' | translateSafe }}
                                </button>
                            </div>
                        </div>

                        <ng-container *ngIf="(filterService.filter$ | async)?.total as total">
                            <div class="col-12" *ngIf="total | existsAndGreaterThanZero">
                                <div class="load-more">
                                    <app-load-more
                                        *ngIf="(filterService.filterList$ | async)?.length as productsLength"
                                        [pending]="filterService.pending$ | async"
                                        [current]="productsLength"
                                        [total]="total"
                                        (loadMore)="
                                            filterService.update(
                                                { take: filterService.defaultTakeAmount, from: productsLength },
                                                true
                                            )
                                        "
                                    ></app-load-more>
                                </div>
                            </div>
                        </ng-container>

                        <div
                            class="col-12"
                            *ngIf="properties?.filterSEOHeadline || properties?.filterSEODescription"
                        >
                            <div class="seo-text">
                                <h2 *ngIf="properties?.filterSEOHeadline as seoHeadline">{{ seoHeadline }}</h2>
                                <div
                                    *ngIf="properties?.filterSEODescription as seoDescription"
                                    class="kk-rte"
                                    [innerHTML]="seoDescription | safe: 'html'"
                                ></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<ng-template #pending>
    <div class="col-12 list-pending-dots">
        <app-loading-dots></app-loading-dots>
    </div>
</ng-template>
